<template>
  <img src="/2017/Venue/auditorium1.jpg" alt="Charles Perkins Auditorium" class="float-right" />
  <p>
    VIZBI 2017 was held at the
    <a href="https://sydney.edu.au/perkins/" target="_blank">Charles Perkins Centre Auditorium</a>
    (CPC), located on The University of Sydney campus:
  </p>
  <p style="margin-left: 2em;">
    <a href="http://sydney.edu.au/perkins/contact/CPC-access-vehicle-pedestrian.pdf" target="_blank">
      Building D17, The University of Sydney,<br />
      Johns Hopkins Drive,<br />
      Camperdown NSW 2050<br />
      Australia
    </a>
  </p>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.0796568245228!2d151.18109911477902!3d-33.88760227746542!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12b02b823f5127%3A0xd8dfdc075992e439!2sCPC+Lecture+Theatre!5e0!3m2!1sen!2sau!4v1496296455159"
    width="600" height="450" frameborder="0"
    style="border:0" allowfullscreen />
  <p>
    CPC is located on the northwest boundary of the University of Sydney Camperdown Campus,
    bordering St John&rsquo;s College and in close proximity to the Royal Prince Alfred Hospital
    (RPA). You can explore The University of Sydney campus with a
    <a href="http://tour.sydney.edu.au" target="_blank">virtual tour</a>.
  </p>
  <p>
    <strong>How to get to the Charles Perkins Centre</strong><br />
    There are two main entrances: one is just past Victoria Park where Broadway becomes Parramatta
    Road; the other is on City Road at the corner of Butlin Avenue. If travelling by train, Redfern
    is the closest station &mdash; a 10-minute walk to the main campus via Abercrombie Street. A
    free shuttle bus ran between Fisher Library and Redfern Station in the evening during semester.
    Central station is a 15-minute walk along City Road and George Street; buses to and from Central
    are frequent from Parramatta Road or City Road. Use the
    <a href="http://sydney.edu.au/maps/">campus map</a> to locate the closest bus stop. For more
    information, see
    <a href="http://sydney.edu.au/campus-life/getting-to-campus.html">how to get to and around</a>
    the Camperdown campus.
  </p>
  <h4>Accommodation</h4>
  <p>
    A block booking at special rates was secured at
    <a href="http://www.rydges.com/accommodation/sydney-nsw/camperdown/welcome/" target="_blank">
      <em>Rydges, Camperdown</em></a>. Rydges is a short five-minute walk to The University of
    Sydney &amp; the Charles Perkins Centre, and approximately 30 minutes from Sydney Airport by
    taxi. The rooms available were Superior Queen at a rate of AU$159 (inclusive of GST).
  </p>
  <h4>Arriving in Australia</h4>
  <p><em>Please remember to arrange a valid visa to enter the country.</em></p>
  <p>
    For a summary of key steps and procedures when arriving at Sydney Airport on an international
    flight, visit the
    <a href="http://www.sydneyairport.com.au/prepare/arrivals/intl-arrival-procedures.aspx" target="_blank">
      International arrivals procedures page</a>.
    For information about duty free allowances, visit the
    <a href="http://www.sydneyairport.com.au/shop/heinemann-tax-and-duty-free/duty-free-allowances.aspx" target="_blank">
      Duty Free allowances page</a>.
  </p>
  <h4>Travelling From the Airport To the City</h4>
  <p>
    Airport Link is a fast and convenient way to reach the centre of Sydney. Trains run
    approximately every 10 minutes and the journey to the city takes only 13 minutes. Train stations
    are located at both the International and Domestic terminals. For train schedules and trip
    planning, visit
    <a href="http://www.airportlink.com.au/" target="_blank">airportlink.com.au</a>.
  </p>
  <h4>Getting Around Sydney</h4>
  <p>
    The best and cheapest way to travel around Sydney is via
    <a href="http://www.transportnsw.info/en/travelling-with-us/visitors/index.page?" target="_blank">
      public transport</a>. To travel on public transport you will need an
    <a href="https://www.opal.com.au/en/get-an-opal-card/" target="_blank">Opal card</a> or an
    <a href="https://www.opal.com.au/en/get-an-opal-card/opal-single-tickets/" target="_blank">
      Opal single ticket</a>. Opal cards can be purchased at the Airport Train Station, Relay and
    WH Smith stores within the airport. To plan your trip, consult Google Maps or the
    <a href="https://tp.transportnsw.info/nsw/XSLT_TRIP_REQUEST2?language=en" target="_blank">
      real-time trip planner</a>. Taxi and Uber services are also available throughout Sydney.
  </p>
  <h4>What to do in Sydney</h4>
  <p>
    Sydney is one of the world&rsquo;s most loved cities. VIZBI 2017 coincided with the
    <a href="https://www.vividsydney.com/" target="_blank">VIVID light festival</a>, the world&rsquo;s
    largest festival of light, music and ideas. There are always plenty of
    <a href="http://www.sydney.com/things-to-do" target="_blank">things to do</a> in Sydney. For
    more information, visit
    <a href="http://www.sydney.com/" target="_blank">the official Sydney website</a>.
  </p>
  <h4>FAQs</h4>
  <p>
    <strong>What is the currency in Australia?</strong><br />
    Australia&rsquo;s national currency is Australian dollars (AUD), in denominations of $5, $10,
    $20, $50 and $100 notes. Coins come in 5, 10, 20 and 50 cents and one and two dollar
    denominations.
  </p>
  <p>
    <strong>What is Goods and Services Tax?</strong><br />
    Australia has a Goods and Services Tax (GST) of 10&#37;. You may be able to claim a refund for
    GST paid on goods if you spent AUD$300 or more with a single business no more than 60 days
    before departing Australia. See the
    <a href="https://www.border.gov.au/Trav/Ente/Tour" target="_blank">Tourist Refund Scheme</a>.
  </p>
  <p>
    <strong>Is tipping customary in Australia?</strong><br />
    Hotels and restaurants do not add service charges to your bill, and tipping is always your
    choice. In upmarket restaurants, it is common to tip waiters 10 per cent of the bill for good
    service.
  </p>
  <p>
    <strong>What kind of electrical plugs are used in Australia?</strong><br />
    The adapter required for Australia is Type 1: two flat metal pins forming an inverted
    &lsquo;V&rsquo; shape, occasionally with a third pin in the centre. The electrical current in
    Australia is 220&ndash;240 volts, AC 50Hz.
  </p>
  <p>
    <strong>What is the international dialling code for Australia?</strong><br />
    The international dialling code for Australia is 61. The area code for New South Wales (Sydney)
    is 02. When calling from outside Australia, leave out the leading &lsquo;0&rsquo; from the area
    code. The outgoing IDD code from within Australia is 0011.
  </p>
  <p>
    <strong>Can I use credit cards in Australia?</strong><br />
    American Express, Diners Club, MasterCard, Visa, UnionPay and JCB are accepted in Australia.
    Traveller&rsquo;s cheques are not widely accepted. Use the
    <a href="http://www.xe.com/currencyconverter/" target="_blank">XE Currency Converter</a> to
    convert your currency to Australian dollars.
  </p>
</template>

<style scoped>
.float-right {
  float: right;
  margin: 0 0 1em 1.5em;
  max-width: 40%;
}
iframe {
  max-width: 100%;
  margin-bottom: 1em;
}
</style>
